import { PAYRUN } from "@/constants/testIds";

const STEPS = [
    { n: 1, label: "Employees set" },
    { n: 2, label: "Hours imported" },
    { n: 3, label: "Review numbers" },
    { n: 4, label: "Approve & pay" },
];

export default function WorkflowStrip({ active = 3 }) {
    return (
        <div className="flex items-center gap-8 mb-8">
            <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-500 font-display">
                Workflow
            </div>
            {STEPS.map((s, i) => {
                const isActive = s.n === active;
                const isDone = s.n < active;
                return (
                    <div key={s.n} data-testid={PAYRUN.workflowStep(s.n)} className="flex items-center gap-2">
                        <span
                            className="inline-flex items-center justify-center w-5 h-5 text-[10px] font-display font-bold rounded-[3px]"
                            style={{
                                background: isActive ? "var(--kp-red)" : isDone ? "var(--kp-charcoal)" : "#E5E5E7",
                                color: isActive || isDone ? "#fff" : "#8B8B90",
                            }}
                        >
                            {s.n}
                        </span>
                        <span
                            className={`text-[11px] uppercase tracking-[0.12em] font-display ${
                                isActive ? "text-[color:var(--kp-charcoal)] font-semibold" : "text-neutral-500"
                            }`}
                        >
                            {s.label}
                        </span>
                        {i < STEPS.length - 1 && <span className="text-neutral-300 ml-4">·</span>}
                    </div>
                );
            })}
        </div>
    );
}
